import styled from 'styled-components';
import { mq } from '~/styles/grid';
import Container from '~/grid/Container';
import getSpacing from '~/helpers/getSpacing';
import { HeadlineLevel } from '../../atoms/Headline/Headline';
import { Headline800, Headline500 } from '../../atoms/Headline';
import CTA from '../../atoms/CTA';

/**
 * @param {string} lineHeight
 * @returns {number}
 */
const getLineHeightCompensation = (lineHeight) => {
  const value = parseFloat(lineHeight);

  if (Number.isNaN(value)) return 0;

  // "120%" -> 0.1em
  if (String(lineHeight).includes('%')) {
    return (value - 100) / 200;
  }

  // "1.2" oder 1.2 -> 0.1em
  return (value - 1) / 2;
};

/**
 * @param {number} basePx
 * @param {string} lineHeight
 * @returns {string}
 */
const getOpticalTopSpacing = (basePx, lineHeight) => {
  const compensation = getLineHeightCompensation(lineHeight);
  return `calc(${basePx}px - ${compensation}em)`;
};

const HeadlineWrapper = styled.div`
  transition: margin-top 1s ease-out;
  ${(props) => getSpacing(props.theme.pageHeading.spacingTop, 'pbottom')};
  margin-top: ${({ theme, $hasTopImage }) =>
    getOpticalTopSpacing(
      $hasTopImage ? 30 : 90,
      theme.headline.h800.xl.lineHeight,
    )};

  @media (${mq.smDown}) {
    margin-top: ${({ theme, $hasTopImage }) =>
      getOpticalTopSpacing(
        $hasTopImage ? 10 : 67,
        theme.headline.h800.xs.lineHeight,
      )};
  }
`;

const SubHeadlineStyled = styled(Headline500)`
  margin-top: ${(props) => props.theme.spacing.xl.spacing400};
  @media (${mq.smDown}) {
    margin-top: ${(props) => props.theme.spacing.xs.spacing400};
  }
`;

/**
 * @param {TopHeadingProps} props
 * @returns {React.ReactElement} The rendered component
 */
const PageHeading = ({ headlineText, bodyText, link, label, hasTopImage }) => {
  return (
    <Container>
      <HeadlineWrapper $hasTopImage={hasTopImage}>
        <Headline800 level={HeadlineLevel.h1}>{headlineText}</Headline800>
        {bodyText && (
          <SubHeadlineStyled level={HeadlineLevel.h2}>
            {bodyText}{' '}
            {link && <CTA href={link} skin="LINK" text={label || link} />}
          </SubHeadlineStyled>
        )}
      </HeadlineWrapper>
    </Container>
  );
};

export default PageHeading;
